import styled from 'styled-components';
import {
  colorBlack900,
  colorGrey400,
  fontFamilyPrimary,
  fontFamilySecondary,
  mediaQueryMobileLargeMin,
} from 'styles';
import { Wrapper as SectionWrapper } from 'components/CurrencyExchangeTable/styles';
import { Paragraph } from 'components/Typography';
import { CommentsLink } from 'components/ExchangeDiscussion/styles';

export const Wrapper = styled(SectionWrapper)``;

export const NewsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-top: 15px;

  @media all and ${mediaQueryMobileLargeMin} {
    flex-direction: row;
  }
`;

export const PrimaryNews = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 306px;
  padding: 28px 23px;
  margin-bottom: 12px;
  border-radius: 4px;
  background-image: url(${props => props.img});
  background-size: cover;
  background-position: center;
  z-index: 1;
  overflow: hidden;

  &:after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.28);
    z-index: -1;
  }

  @media all and ${mediaQueryMobileLargeMin} {
    width: 46%;
    margin-bottom: 0;
    height: unset;
  }
`;

export const SecondaryNews = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;

  @media all and ${mediaQueryMobileLargeMin} {
    width: 51.8%;
    margin-bottom: 0;
  }
`;

export const SecondaryNewsItem = styled.a`
  display: block;
  background: #f6f5f8;
  border-radius: 4px;
  width: 100%;
  padding: 12px 16px;
  margin-bottom: 12px;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }

  &:active {
    opacity: 0.9;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

export const NewsText = styled(Paragraph)`
  line-height: 20px;
  color: ${colorBlack900};

  ${({ primary }) =>
    primary &&
    ` 
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    line-height: 28px;
    font-family: ${fontFamilySecondary};
    `}
`;

export const NewsUpdate = styled.span`
  display: inline-block;
  margin-bottom: 4px;
  line-height: 18px;
  font-family: ${fontFamilyPrimary};
  font-size: 13px;
  color: ${colorGrey400};

  ${({ primary }) =>
    primary &&
    ` 
    color: #fff;
    `}
`;

export const AllNews = styled(CommentsLink)`
  margin-top: 0;

  @media all and ${mediaQueryMobileLargeMin} {
    margin-top: 16px;
  }
`;
